import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  // Main colors
  const bgColor = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const headingColor = useColorModeValue('navy.700', 'white');
  const subTextColor = useColorModeValue('gray.600', 'gray.300');

  // Input colors
  const inputColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');

  // Button and interactive colors
  const iconBgColor = useColorModeValue('gray.200', 'whiteAlpha.300');
  const iconColor = useColorModeValue('gray.600', 'gray.300');
  const toolbarBg = useColorModeValue('gray.50', 'navy.900');

  // Preview and content colors
  const previewBg = useColorModeValue('white', 'gray.800');
  const previewTextColor = useColorModeValue('gray.800', 'gray.100');

  // Card and layout colors
  const cardBg = useColorModeValue('white', 'navy.800');
  const backgroundCardColor = useColorModeValue('white', 'whiteAlpha.100');

  // Tab colors
  const tabBg = useColorModeValue('gray.50', 'navy.900');
  const tabActiveBg = useColorModeValue('white', 'navy.700');
  const tabBorderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

  // Status colors
  const successColor = useColorModeValue('green.500', 'green.300');
  const errorColor = useColorModeValue('red.500', 'red.300');
  const warningColor = useColorModeValue('yellow.500', 'yellow.300');

  // Hover colors
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.100');
  const hoverColor = useColorModeValue('blue.500', 'blue.300');

  return {
    // Main colors
    bgColor,
    borderColor,
    textColor,
    headingColor,
    subTextColor,

    // Input colors
    inputColor,
    placeholderColor,

    // Button and interactive colors
    iconBgColor,
    iconColor,
    toolbarBg,

    // Preview and content colors
    previewBg,
    previewTextColor,

    // Card and layout colors
    cardBg,
    backgroundCardColor,

    // Tab colors
    tabBg,
    tabActiveBg,
    tabBorderColor,

    // Status colors
    successColor,
    errorColor,
    warningColor,

    // Hover colors
    hoverBg,
    hoverColor,
  };
};
